import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "s20_mobile px-4" }
const _hoisted_2 = { class: "widget px-7 py-7" }
const _hoisted_3 = { class: "s10_mobile container-full-2" }
const _hoisted_4 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-floating lg reactive active my-5" }
const _hoisted_7 = ["readonly"]
const _hoisted_8 = {
  key: 1,
  class: "text-red"
}
const _hoisted_9 = { class: "form-field-floating active my-4" }
const _hoisted_10 = ["value"]
const _hoisted_11 = {
  key: 2,
  class: "text-red"
}
const _hoisted_12 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_13 = {
  key: 3,
  class: "text-red"
}
const _hoisted_14 = { class: "form-field-split active my-5" }
const _hoisted_15 = { class: "form-field-floating lg reactive half" }
const _hoisted_16 = ["readonly"]
const _hoisted_17 = {
  key: 4,
  class: "text-red"
}
const _hoisted_18 = {
  key: 5,
  class: "text-red"
}
const _hoisted_19 = { class: "form-field-floating lg reactive my-5" }
const _hoisted_20 = {
  key: 6,
  class: "text-red"
}
const _hoisted_21 = { class: "s10_mobile container-full-2" }
const _hoisted_22 = { class: "logo-uploader" }
const _hoisted_23 = { class: "logo-preview" }
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 2,
  class: "logo-placeholder"
}
const _hoisted_27 = { class: "logo-actions" }
const _hoisted_28 = {
  for: "logo-input",
  class: "btn lg white2 active",
  style: {"cursor":"pointer"}
}
const _hoisted_29 = { class: "s10_mobile container-full-2" }
const _hoisted_30 = { class: "grid2 grid-row-gap-0" }
const _hoisted_31 = ["for"]
const _hoisted_32 = { class: "card-check-text" }
const _hoisted_33 = ["id", "value"]
const _hoisted_34 = { class: "font-semibold mt-1 mb-2 align-right" }
const _hoisted_35 = {
  key: 0,
  class: "text-red"
}
const _hoisted_36 = { class: "s10_mobile container-full-2" }
const _hoisted_37 = {
  key: 0,
  class: "text-red"
}
const _hoisted_38 = { class: "flex gap-2" }

import { useToastStore } from '@/stores/toast.store';
    import axios from 'axios';
    import moment from 'moment';
    import { inject, onMounted, reactive, Ref, ref } from 'vue';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CollectivitesManagementInformations',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const toastStore = useToastStore();
    const errorMessage = ref('');
    const loading = ref(false);
    const collectivite = inject<Ref<any>>('collectivite');
    const startupFormDatas = reactive({
        pays: [] as any[],
        users: [] as any[]
    });
    const BACKEND_URL = inject('BACKEND_URL');
    const logoPreview = ref<string | null>(null);
    const existingLogo = ref<string | null>(null);
    const formData = reactive({
        id: null as number | null,
        nom: "",
        rccm: "",
        adresse: "",
        telephone: "",
        email: "",
        date_creation: "",
        pays_id: null as number | null,
        secteurs: [] as string[],
        gerant_id: null as number | null, // ID de l'utilisateur existant à associer
        logo: null as File | null
    });
    const errors = reactive({
        nom: "",
        rccm: "",
        adresse: "",
        telephone: "",
        email: "",
        date_creation: "",
        pays_id: "",
        secteurs: ""
    });
    const secteurs = ref([
      { id: 'finance', value: 'Finance', label: 'Finance' },
      { id: 'informatique', value: 'Informatique', label: 'Informatique' },
      { id: 'agriculture', value: 'Agriculture', label: 'Agriculture' },
      { id: 'education', value: 'Éducation', label: 'Éducation' },
      { id: 'sante', value: 'Santé', label: 'Santé' },
      { id: 'transport', value: 'Transport', label: 'Transport' },
      { id: 'construction', value: 'Construction', label: 'Construction' },
      { id: 'commerce', value: 'Commerce', label: 'Commerce' },
      { id: 'industrie', value: 'Industrie', label: 'Industrie' },
      { id: 'autre', value: 'Autre', label: 'Autre' }
    ]);

    onMounted(() => {
        const form_datas = route.meta.form_datas as { collectivite: any, startupFormDatas: any };
        Object.assign(startupFormDatas, form_datas.startupFormDatas);
        if (form_datas.collectivite) {
            const collectivite = form_datas.collectivite as any;
            if (collectivite.date_creation) {
                const date_creation = moment(collectivite.date_creation);
                collectivite.date_creation = date_creation.isValid() ? date_creation.format('YYYY-MM-DD') : '';
            }
            Object.assign(formData, collectivite);
            formData.secteurs = normalizeSecteurs(collectivite.secteurs);
            existingLogo.value = collectivite.logo || null;
        }
    });

    function normalizeSecteurs(raw: any): string[] {
        if (!Array.isArray(raw)) return [];
        const canonical = new Map(secteurs.value.map((s: any) => [String(s.value).toLowerCase(), s.value]));
        return raw.map((v: any) => {
            const key = String(v).toLowerCase();
            return canonical.get(key) ?? String(v);
        });
    }

    function onLogoSelected(event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file) return;
        formData.logo = file;
        const reader = new FileReader();
        reader.onload = (e) => { logoPreview.value = e.target?.result as string; };
        reader.readAsDataURL(file);
    }

    function clearLogo() {
        formData.logo = null;
        logoPreview.value = null;
    }

    function validate() {
        let isValid = true;
        errors.nom = '';
        if (!formData.nom) {
            errors.nom = "Le nom est requis";
            isValid = false;
        }

        errors.pays_id = '';
        if (!formData.pays_id || formData.pays_id <= 0) {
            errors.pays_id = "Le pays est requis";
            isValid = false;
        }

        errors.rccm = '';
        if (!formData.rccm) {
            errors.rccm = "Le RCCM est requis";
            isValid = false;
        }

        errors.adresse = '';
        if (!formData.adresse) {
            errors.adresse = "L'adresse est requise";
            isValid = false;
        }

        errors.telephone = '';
        if (!formData.telephone) {
            errors.telephone = "Le téléphone est requis";
            isValid = false;
        }

        errors.email = '';
        if (!formData.email) {
            errors.email = "L'email est requis";
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Le format de l'email est invalide";
            isValid = false;
        }

        errors.secteurs = '';
        if (!formData.secteurs || formData.secteurs.length === 0) {
            errors.secteurs = "Au moins un secteur est requis";
            isValid = false;
        }

        errors.date_creation = '';
        if (!formData.date_creation) {
            errors.date_creation = "La date de création est requise";
            isValid = false;
        }

        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            // Utiliser FormData pour supporter l'upload de photo
            const formToUpload = new FormData();

            if (formData.id) {
                formToUpload.append('id', String(formData.id));
            }
            formToUpload.append('nom', formData.nom);
            formToUpload.append('rccm', formData.rccm);
            formToUpload.append('adresse', formData.adresse);
            formToUpload.append('telephone', formData.telephone);
            formToUpload.append('email', formData.email);
            formToUpload.append('pays_id', String(formData.pays_id));
            formToUpload.append('date_creation', formData.date_creation);
            formData.secteurs.forEach((secteur, index) => {
                formToUpload.append(`secteurs[${index}]`, secteur);
            });
            if (formData.logo) {
                formToUpload.append('logo', formData.logo);
            }
            const response = await axios.post(`/backoffice/collectivites/save_collectivite`, formToUpload);
            const savedCollectivite = response.data.collectivite;
            toastStore.success('Collectivité enregistré !');
            
            setTimeout(() => {
                window.location.href = `/app/collectivites/manage/${savedCollectivite.id}/gerant`;
            }, 100);
        } catch(error: any) {
            errorMessage.value = error.response?.data?.message || error.message || "Une erreur est survenue";
            console.error(error);
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, [
        _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-info-perso.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Informations ")
        ])
      ], -1)),
      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "nom",
            id: "nom",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.nom]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "nom" }, [
            _createTextVNode("Désignation de la collectivité "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['nom'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['nom']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "rccm",
            id: "rccm",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.rccm) = $event)),
            placeholder: "",
            readonly: _unref(collectivite)?.verrouille
          }, null, 8, _hoisted_7), [
            [_vModelText, formData.rccm]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "rccm" }, [
            _createTextVNode("Numéro du registre de commerce "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['rccm'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(errors['rccm']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            name: "pays_id",
            id: "pays_id",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.pays_id) = $event))
          }, [
            _cache[11] || (_cache[11] = _createElementVNode("option", {
              value: null,
              selected: ""
            }, "Sélectionnez un pays", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(startupFormDatas.pays, (pays, index) => {
              return (_openBlock(), _createElementBlock("option", {
                value: pays.id,
                key: 'pays_' + index
              }, _toDisplayString(pays.nom), 9, _hoisted_10))
            }), 128))
          ], 512), [
            [_vModelSelect, formData.pays_id]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", { for: "pays_id" }, [
            _createTextVNode("Pays "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['pays_id'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['pays_id']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            name: "adresse",
            id: "adresse",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.adresse) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.adresse]
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "adresse" }, [
            _createTextVNode("Adresse de l'entreprise "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['adresse'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors['adresse']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_custom_phone_input, {
            modelValue: formData.telephone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.telephone) = $event)),
            id: "telephone",
            classesNames: "half",
            readonly: _unref(collectivite)?.verrouille
          }, null, 8, ["modelValue", "readonly"]),
          _cache[15] || (_cache[15] = _createElementVNode("hr", { class: "hr" }, null, -1)),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("input", {
              type: "email",
              class: "form-input",
              name: "email",
              id: "email",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.email) = $event)),
              placeholder: "",
              readonly: _unref(collectivite)?.verrouille
            }, null, 8, _hoisted_16), [
              [_vModelText, formData.email]
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "email" }, [
              _createTextVNode("Adresse Email "),
              _createElementVNode("b", { class: "color-danger" }, "*")
            ], -1))
          ])
        ]),
        (!!errors['telephone'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors['telephone']), 1))
          : _createCommentVNode("", true),
        (!!errors['email'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errors['email']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _withDirectives(_createElementVNode("input", {
            type: "date",
            class: "form-input",
            name: "date_creation",
            id: "date_creation",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.date_creation) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, formData.date_creation]
          ]),
          _cache[16] || (_cache[16] = _createElementVNode("label", { for: "date_creation" }, "Date de création", -1))
        ]),
        (!!errors['date_creation'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(errors['date_creation']), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_21, [
        _cache[19] || (_cache[19] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-info-collectivite.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Logo ")
        ], -1)),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            (logoPreview.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: logoPreview.value,
                  alt: "Aperçu"
                }, null, 8, _hoisted_24))
              : (existingLogo.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: `${_unref(BACKEND_URL)}/assets/collectivites/${existingLogo.value}`,
                    alt: "Logo actuel"
                  }, null, 8, _hoisted_25))
                : (_openBlock(), _createElementBlock("span", _hoisted_26, "Aucun logo"))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, [
              _cache[17] || (_cache[17] = _createElementVNode("img", {
                src: "/icons/icon-upload.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(existingLogo.value || formData.logo ? 'Remplacer le logo' : 'Choisir un logo'), 1)
            ]),
            _createElementVNode("input", {
              id: "logo-input",
              type: "file",
              accept: "image/*",
              style: {"display":"none"},
              onChange: onLogoSelected
            }, null, 32),
            (formData.logo)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn lg white2",
                  onClick: clearLogo
                }, " Annuler la sélection "))
              : _createCommentVNode("", true),
            _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-sm text-grey-500 mt-2" }, "PNG, JPG, SVG · max 5 Mo", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_29, [
        _cache[20] || (_cache[20] = _createElementVNode("h2", { class: "flex align-items-center gap-4 font-medium text-primary-color my-5" }, [
          _createElementVNode("img", {
            src: "/public/icons/icon-secteur-activite.svg",
            class: "size-l",
            alt: ""
          }),
          _createTextVNode(" Secteur d'activité ")
        ], -1)),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secteurs.value, (secteur) => {
            return (_openBlock(), _createElementBlock("div", {
              key: secteur.id,
              class: "card-check lg single"
            }, [
              _createElementVNode("label", {
                class: "form-check-label",
                for: `secteur_${secteur.id}`
              }, [
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input left",
                    type: "checkbox",
                    name: "secteur[]",
                    id: `secteur_${secteur.id}`,
                    value: secteur.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.secteurs) = $event))
                  }, null, 8, _hoisted_33), [
                    [_vModelCheckbox, formData.secteurs]
                  ]),
                  _createElementVNode("h6", _hoisted_34, _toDisplayString(secteur.label), 1)
                ])
              ], 8, _hoisted_31)
            ]))
          }), 128))
        ]),
        (!!errors['secteurs'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(errors['secteurs']), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[25] || (_cache[25] = _createElementVNode("div", { class: "s10_mobile container-full-2" }, " ", -1)),
      _createElementVNode("div", _hoisted_36, [
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[22] || (_cache[22] = _createElementVNode("p", { class: "text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_custom_button, {
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[8] || (_cache[8] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Valider", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      _cache[26] || (_cache[26] = _createElementVNode("div", { class: "clear-both h-25" }, null, -1))
    ])
  ]))
}
}

})